import UpperBodyQuestions from './upper-body-questions';

export default UpperBodyQuestions;
